import { WeeklyDayPickerBase } from './WeeklyDayPicker.base';
import { styles } from './WeeklyDayPicker.styles';
import { styled } from '../../Utilities';
export var WeeklyDayPicker = styled(WeeklyDayPickerBase, styles, undefined, { scope: 'WeeklyDayPicker' });
//# sourceMappingURL=WeeklyDayPicker.js.map